export const inputSetter = (
  setState:
    | ((value: React.SetStateAction<string>) => void)
    | ((value: string) => void)
) => (e: React.ChangeEvent<HTMLInputElement>) => {
  const target = e.target;
  setState(target.value);
};
